import firebase from "firebase";
// import router from "@/router/index.js";

const state = {
  allUseres: []
};

const getters = {
  getUseres(state) {
    return state.allUseres;
  }
};

const mutations = {
  setUseres(state, payload) {
    state.allUseres = payload;
  }
};

const actions = {
  getAllUseres({ commit }) {
    const users = [];
    commit("setLoading", true);
    firebase
      .firestore()
      .collection("users")
      .get()
      .then(snapshot => {
        snapshot.docs.forEach(doc => {
          var item = doc.data();
          users.push(item);
        });
      })
      .finally(() => {
        commit("setLoading", false);
        commit("setUseres", users);
      })
      .catch(err => {
        /*eslint-disable*/
        console.log(err);
        commit("setLoading", false);
      });
  },
  changeUserStatus({ commit, dispatch }, payload) {
    const { id, status } = payload;
    commit("setLoading", true);
    firebase
      .firestore()
      .collection("users")
      .where("id", "==", id)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          firebase
            .firestore()
            .collection("users")
            .doc(doc.id)
            .set(
              {
                status: status
              },
              { merge: true }
            )
            .then(resp => {
              dispatch("getAllUseres");
              commit("setLoading", false);
            });
        });
      });
  },
  deleteSelectedUser({ commit, dispatch }, payload) {
    commit("setLoading", true);
    firebase
      .firestore()
      .collection("users")
      .where("id", "==", payload)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          doc.ref.delete().then(() => {
            dispatch("getAllUseres");
            commit("setLoading", false);
          });
        });
      });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
